import React from "react";
import { Button, getPrettyNumber } from "aible";

import { DATA_CHECKS } from "containers/Home/reducer";
import {
  ReviewDatasetHeader,
  ReviewDatasetItem,
  ExpansionItem
} from "components/CreateWizard/Academic/AcademicReviewDataset";
import ProblematicPredictors from "components/CreateWizard/Academic/ProblematicPredictors";
import { ProblematicPredictorLabel, ProblematicPredictorBar } from "components/CreateWizard/Dataset/Correlation";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export const SUBGROUP_DATA = {
  aiReadyFields: [
    { label: "Region", value: 1 },
    { label: "StageName", value: 0.98153 },
    { label: "CloseDate", value: 0.87198396793587174 },
    { label: "X3_Month_LIBOR_Rate__c", value: 0.7655310621242485 }
  ],
  notAiReadyFields: [
    { label: "Contact_Type__c", value: 0.31382765531062127 },
    { label: "Channel", value: 0.11032064128256512 },
    { label: "Amount", value: 0.012024048096192385 },
    { label: "AccountId", value: 0.002004008016032064 },
    { label: "Last_Contact_Duration__c", value: 0.002004008016032064 },
    { label: "Num_Contacts_per_Month__c", value: 0.001002004008016032 }
  ],
  problematicPredictors: [
    {
      label: "StageName",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.9528357208926,
      data: [
        { value: "Closed Lost", count: 5791 },
        { value: "Closed Won", count: 691 }
      ]
    }
  ],
  predictors: [
    {
      label: "Last_Contact_Duration__c",
      ignored: false,
      type: "number",
      warnings: [],
      rulefit: [],
      min: 3,
      max: 2870,
      correlation: 0.35901785535513
    },
    {
      label: "X3_Month_LIBOR_Rate__c",
      ignored: false,
      type: "number",
      warnings: [],
      rulefit: [],
      min: 0,
      max: 4,
      correlation: 0.34202667590145
    },
    {
      label: "Amount",
      ignored: false,
      type: "number",
      warnings: [],
      rulefit: [],
      min: 23,
      max: 397155,
      correlation: 0.274780120031574
    },
    {
      label: "Previous_Opportunity_Outcome__c",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.163414045262377,
      data: [
        { value: "Nonexistent", count: 5654 },
        { value: "Failure", count: 641 },
        { value: "Success", count: 187 }
      ]
    },
    {
      label: "Purchasing_Managers_Index__c",
      ignored: false,
      type: "number",
      warnings: [],
      rulefit: [],
      min: 46,
      max: 47,
      correlation: 0.12571641453762
    },
    {
      label: "Contact_Type__c",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.120835389464574,
      data: [
        { value: "Cellular", count: 3794 },
        { value: "Telephone", count: 2688 }
      ]
    },
    {
      label: "Type",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.107501628608315,
      data: [
        { value: "Replacement", count: 2607 },
        { value: "Upsell", count: 2218 },
        { value: "New Customer", count: 1657 }
      ]
    },
    {
      label: "Credit_Risk__c",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.106320155315396,
      data: [
        { value: "Low", count: 5030 },
        { value: "Unknown", count: 1452 }
      ]
    },
    {
      label: "Region",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.10004233018031078,
      data: [
        { value: "US", count: 3766 },
        { value: "EMEA", count: 2611 },
        { value: "LATAM", count: 105 }
      ]
    },
    {
      label: "Channel",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.08432795054033487,
      data: [
        { value: "Digital Marketing", count: 3970 },
        { value: "Events", count: 1781 },
        { value: "Other", count: 731 }
      ]
    },
    {
      label: "Campaign_Name",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.04835385931631,
      data: [
        { value: "Campaign A", count: 1362 },
        { value: "Campaign D", count: 1316 },
        { value: "Campaign E", count: 1291 },
        { value: "Campaign B", count: 1272 },
        { value: "Campaign C", count: 1241 }
      ]
    },
    {
      label: "AccountId",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.03680341905888028,
      data: [
        { value: "0013i00000362e6AAA", count: 2124 },
        { value: "0013i00000362e5AAA", count: 1005 },
        { value: "0013i00000362e1AAA", count: 818 },
        { value: "0013i00000362eBAAQ", count: 661 },
        { value: "0013i00000362e8AAA", count: 616 },
        { value: "0013i00000362e7AAA", count: 606 },
        { value: "0013i00000362e2AAA", count: 225 },
        { value: "0013i00000362e3AAA", count: 214 },
        { value: "0013i00000362e4AAA", count: 213 }
      ]
    }
  ]
};

export const OVERALL_DATA = {
  aiReadyFields: [
    { label: "Region", value: 1 },
    { label: "StageName", value: 1 },
    { label: "Purchasing_Managers_Index__c", value: 1 },
    { label: "X3_Month_LIBOR_Rate__c", value: 0.7655310621242485 }
  ],
  notAiReadyFields: [
    { label: "CloseDate", value: 0.49198396793587174 },
    { label: "Contact_Type__c", value: 0.41382765531062127 },
    { label: "Channel", value: 0.16032064128256512 },
    { label: "Amount", value: 0.012024048096192385 },
    { label: "AccountId", value: 0.002004008016032064 },
    { label: "Last_Contact_Duration__c", value: 0.002004008016032064 },
    { label: "Num_Contacts_per_Month__c", value: 0.001002004008016032 }
  ],
  problematicPredictors: [
    {
      label: "StageName",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.9997728357208926,
      data: [
        { value: "Closed Lost", count: 5791 },
        { value: "Closed Won", count: 691 }
      ]
    }
  ],
  predictors: [
    {
      label: "Last_Contact_Duration__c",
      ignored: false,
      type: "number",
      warnings: [],
      rulefit: [],
      min: 3,
      max: 2870,
      correlation: 0.4095901785535513
    },
    {
      label: "X3_Month_LIBOR_Rate__c",
      ignored: false,
      type: "number",
      warnings: [],
      rulefit: [],
      min: 0,
      max: 4,
      correlation: 0.3004202667590145
    },
    {
      label: "Amount",
      ignored: false,
      type: "number",
      warnings: [],
      rulefit: [],
      min: 23,
      max: 397155,
      correlation: 0.29474780120031574
    },
    {
      label: "Previous_Opportunity_Outcome__c",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.2463414045262377,
      data: [
        { value: "Nonexistent", count: 5654 },
        { value: "Failure", count: 641 },
        { value: "Success", count: 187 }
      ]
    },
    {
      label: "Purchasing_Managers_Index__c",
      ignored: false,
      type: "number",
      warnings: [],
      rulefit: [],
      min: 46,
      max: 47,
      correlation: 0.14882571641453762
    },
    {
      label: "Contact_Type__c",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.14360835389464574,
      data: [
        { value: "Cellular", count: 3794 },
        { value: "Telephone", count: 2688 }
      ]
    },
    {
      label: "Type",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.1237501628608315,
      data: [
        { value: "Replacement", count: 2607 },
        { value: "Upsell", count: 2218 },
        { value: "New Customer", count: 1657 }
      ]
    },
    {
      label: "Credit_Risk__c",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.1065320155315396,
      data: [
        { value: "Low", count: 5030 },
        { value: "Unknown", count: 1452 }
      ]
    },
    {
      label: "Region",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.10004233018031078,
      data: [
        { value: "US", count: 3766 },
        { value: "EMEA", count: 2611 },
        { value: "LATAM", count: 105 }
      ]
    },
    {
      label: "Channel",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.08432795054033487,
      data: [
        { value: "Digital Marketing", count: 3970 },
        { value: "Events", count: 1781 },
        { value: "Other", count: 731 }
      ]
    },
    {
      label: "Num_Contacts_per_Month__c",
      ignored: false,
      type: "number",
      warnings: [],
      rulefit: [],
      min: 1,
      max: 37,
      correlation: 0.06061703432304995
    },
    {
      label: "LeadSource",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.05227041866300171,
      data: [
        { value: "Web", count: 3895 },
        { value: "Phone Inquiry", count: 1862 },
        { value: "Partner Referral", count: 714 },
        { value: "Purchased List", count: 11 }
      ]
    },
    {
      label: "kWh_Required__c",
      ignored: false,
      type: "number",
      warnings: [],
      rulefit: [],
      min: 18,
      max: 98,
      correlation: 0.019392606656162967
    },
    {
      label: "Campaign_Name",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.01439835385931631,
      data: [
        { value: "Campaign A", count: 1362 },
        { value: "Campaign D", count: 1316 },
        { value: "Campaign E", count: 1291 },
        { value: "Campaign B", count: 1272 },
        { value: "Campaign C", count: 1241 }
      ]
    },
    {
      label: "AccountId",
      ignored: false,
      type: "categorical",
      warnings: [],
      rulefit: [],
      correlation: 0.013680341905888028,
      data: [
        { value: "0013i00000362e6AAA", count: 2124 },
        { value: "0013i00000362e5AAA", count: 1005 },
        { value: "0013i00000362e1AAA", count: 818 },
        { value: "0013i00000362eBAAQ", count: 661 },
        { value: "0013i00000362e8AAA", count: 616 },
        { value: "0013i00000362e7AAA", count: 606 },
        { value: "0013i00000362e2AAA", count: 225 },
        { value: "0013i00000362e3AAA", count: 214 },
        { value: "0013i00000362e4AAA", count: 213 }
      ]
    }
  ]
};

function handlePlurals(count, value = "", noPlural = false) {
  return value + (noPlural || count === 1 ? "" : "s");
}

export default class RetrainFrontiers extends React.PureComponent {
  render() {
    const { isOpen, handleClose, data, ignored, updateIgnored, selectedDataset } = this.props;
    const { label, count } = data || {};
    const { aiReadyFields, notAiReadyFields, problematicPredictors, predictors } =
      label === "Overall" ? OVERALL_DATA : SUBGROUP_DATA;
    return (
      <Dialog open={isOpen} onOpenChange={handleClose}>
        <DialogContent size="lg">
          <DialogHeader>
            <DialogTitle>{"You have enough monitoring data to retrain " + label}</DialogTitle>
          </DialogHeader>
          <div className={styles.retrainFrontiersBody}>
            <div className={styles.retrainFrontiersLabel}>{"Monitoring Data Overview"}</div>
            <div className={styles.retrainFrontiersWrapper}>
              <div className={styles.retrainFrontiersColumn}>
                <ReviewDatasetHeader error={false} header={"Data Validation"} />
                <div className={styles.datasetReviewContent}>
                  <ReviewDatasetItem text={getPrettyNumber(21) + (" Column" + handlePlurals(21) + " Scanned")} />
                  <ReviewDatasetItem text={getPrettyNumber(count) + (" Row" + handlePlurals(count) + " Scanned")} />
                  <ReviewDatasetItem
                    text={
                      getPrettyNumber(DATA_CHECKS.length) +
                      "  " +
                      handlePlurals(DATA_CHECKS.length, "Data Check") +
                      " Completed"
                    }
                    overlayTitle={"Data Checks"}
                    overlay={
                      <div className={styles.datasetReviewPopup}>
                        {DATA_CHECKS.map((w, i) => (
                          <ReviewDatasetItem text={w} key={i + w} />
                        ))}
                      </div>
                    }
                  />
                </div>
              </div>
              <div className={styles.retrainFrontiersColumn}>
                <ReviewDatasetHeader error={false} header={"AI Validation"} />
                <div className={styles.selectSubheader} style={{ marginLeft: "0px" }}>
                  {"Aible scanned the dataset for AI readiness and found that your outcome" +
                    " is" +
                    " appropriate for AutoML modeling"}
                </div>
                <ExpansionItem limit={Math.min(6, aiReadyFields.length + 1)}>
                  <ReviewDatasetItem
                    style={{ width: "100%" }}
                    noIcon
                    text={
                      <React.Fragment>
                        <ProblematicPredictorLabel noMargin noIgnore label={<strong>{"Column"}</strong>} />
                        <ProblematicPredictorLabel
                          noMargin
                          noIgnore
                          noTitle
                          label={<strong>{"Information Score"}</strong>}
                          info={
                            "The AI Validation step checks to see if there is sufficient predictive power in any of your variables for building an AI model. It's okay if your data is messy, there can still be enough to build AI models. Each variable is scored on a scale of 0 - 10."
                          }
                          maxWidth={200}
                        />
                      </React.Fragment>
                    }
                  />
                  {aiReadyFields.map((w, i) => (
                    <ReviewDatasetItem
                      style={{ width: "100%" }}
                      isExpand
                      noIcon
                      key={i}
                      text={
                        <React.Fragment>
                          <ProblematicPredictorLabel noMargin noIgnore label={w.label} />
                          <ProblematicPredictorBar value={w.value} isScore />
                        </React.Fragment>
                      }
                    />
                  ))}
                  {notAiReadyFields.map((w, i) => (
                    <ReviewDatasetItem
                      isExpand
                      noIcon
                      error
                      key={i}
                      text={
                        <React.Fragment>
                          <ProblematicPredictorLabel noMargin noIgnore label={w.label} />
                          <ProblematicPredictorBar value={w.value} isScore />
                        </React.Fragment>
                      }
                    />
                  ))}
                </ExpansionItem>
              </div>
              <div className={styles.retrainFrontiersColumn}>
                <ProblematicPredictors
                  selectedDataset={selectedDataset}
                  problematicPredictors={problematicPredictors}
                  predictors={predictors}
                  updateIgnored={updateIgnored}
                  ignored={ignored}
                />
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button onClick={handleClose} style={{ marginRight: "15px" }}>
              {"Cancel"}
            </Button>
            <Button type="primary" onClick={handleClose}>
              {"Retrain Frontier"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}
